export default function LoadingSkeleton() {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="rounded-xl border border-line bg-white p-4 shadow-soft">
          <div className="h-40 animate-pulse rounded-xl bg-slate-100" />
          <div className="mt-4 h-4 w-2/3 animate-pulse rounded bg-slate-100" />
          <div className="mt-3 h-4 animate-pulse rounded bg-slate-100" />
          <div className="mt-3 h-4 w-1/2 animate-pulse rounded bg-slate-100" />
        </div>
      ))}
    </div>
  );
}
